import { format, parseISO, isValid } from "date-fns";

const formatDateTime = value => {
  if (!value) return "N/A";

  let date;

  if (value instanceof Date) {
    date = value;
  } else if (typeof value === "string") {
    date = parseISO(value);
  } else {
    return "N/A";
  }

  return isValid(date) ? format(date, "dd/MMM/yyyy HH:mm") : "N/A";
};

const formatDate = value => {
  const formatted = formatDateTime(value);
  return formatted !== "N/A" ? formatted.split(" ")[0] : "N/A";
};

const calculateDaysFromToday = date => {
  const opdDate = new Date(date);
  const today = new Date();

  opdDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffTime = today - opdDate;
  return Math.floor(diffTime / (1000 * 60 * 60 * 24));
};

export default formatDateTime;
export { formatDate, calculateDaysFromToday };
